import * as App from './../../app';
import bridge from '@vkontakte/vk-bridge';
import * as Backend from './../../backend-api';
import * as FEATURES from './../../app/const/features';
export function syncBackend() {
    Backend.authApi()
        .then(function (data) {
        if (PRODUCTION) {
            var maxScore_1 = App.storage.get().maxScore;
            if (data && data.name === false) {
                bridge.send('VKWebAppGetUserInfo', {}).then(function (d) {
                    var name = "".concat(d.first_name, " ").concat(d.last_name);
                    Backend.updateProfile({ name: name, maxScore: maxScore_1, avatar: d.photo_100 });
                });
            }
            if (maxScore_1 > data.maxScore) {
                Backend.setScore(maxScore_1);
            }
        }
        if (FEATURES.SAVE_STATE_FEATURE) {
            Backend.saveStateOnServer(App.storage.get());
        }
    })
        .catch(function (_err) {
        App.stat.params({ apiErrors: { init: 1 } });
    });
}
